import axios from 'axios';
import { setupAuthInterceptor, retryWithBackoff } from '../common';
import { wrapAxiosInstance } from '../cache/modules/axiosFactory';
import { NAMESPACES } from '../configuration';
const BASE_URL = NAMESPACES.pedidos_api.pedido_groups;

// Axios instance with auth interceptor (token managed automatically)
const api = setupAuthInterceptor(axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  }
}));

// Cached API wrapper - 30s TTL for pedido groups (changes frequently during service)
const cachedApi = wrapAxiosInstance(api, {
  namespace: 'pedidos_api',
  group: 'pedido_groups',
  defaultTtl: '30s',
  hashLargeSegments: true,
  emitMeta: true,
});

// =====================
// READS (cached)
// =====================

export const getPedidoGroupById = async (pedido_group_id: number) => {
  return await retryWithBackoff(() => cachedApi.get(`/GetPedidoGroupById/${pedido_group_id}`));
};

// Function to get active pedido groups by local ID
export const getActivePedidoGroupsByLocalId = async (local_id: number) => {
  return await retryWithBackoff(() => cachedApi.get(`/GetActivePedidoGroupsByLocalId/${local_id}`));
};

// Get active pedidos by pedido group ID
export const getActivePedidosByGroupId = async (pedido_group_id: number) => {
  return await retryWithBackoff(() => cachedApi.get(`/GetActivePedidosByGroupId/${pedido_group_id}`));
};

// =====================
// MUTATIONS (no cache, invalidate after)
// =====================

// Function to create a new pedido group
export const createPedidoGroup = async (local_id: number) => {
  const res = await retryWithBackoff(() => api.post(`/CreatePedidoGroup/${local_id}`, {}));
  await cachedApi.clear();
  return res;
};

// Function to update pedido group name
export const updatePedidoGroupName = async (pedido_group_id: number, name: string) => {
  const res = await retryWithBackoff(() => api.put(`/UpdatePedidoGroupName/${pedido_group_id}`, { name }));
  await cachedApi.clear();
  return res;
};

// Function to deactivate a pedido group
export const deactivatePedidoGroup = async (pedido_group_id: number) => {
  const res = await retryWithBackoff(() => api.put(`/DeactivatePedidoGroup/${pedido_group_id}`, {}));
  await cachedApi.clear();
  return res;
};

// Delete a pedido group (hard delete - only works for empty groups)
export const deletePedidoGroup = async (pedido_group_id: number) => {
  const res = await retryWithBackoff(() => api.delete(`/DeletePedidoGroup/${pedido_group_id}`));
  await cachedApi.clear();
  return res;
};


